// extracted by mini-css-extract-plugin
export default {"Box":"suggested-item-option-module__Box--KbruS","Box_1":"suggested-item-option-module__Box_1--eky9r","Text":"suggested-item-option-module__Text--yvTOK"};